<template>
	<div id="wordle">
		<div
			id="hideinmobile"
			class="d-flex w-100 justify-content-center align-items-center gap-4 mt-4"
		>
			<h1 id="title" class="mr-4">Wordle</h1>
			<article>
				<h5>Current score</h5>
				<h4>{{ myScore }}</h4>
			</article>
			<article>
				<h5>Best try</h5>
				<h4>{{ bestTry }}</h4>
			</article>
		</div>
		<div
			id="hideinlaptop"
			class="d-flex w-100 justify-content-center align-items-center gap-4 mt-4"
		>
			<article>
				<h5>Current score</h5>
				<h4>{{ myScore }}</h4>
			</article>
			<article>
				<h5>Best try</h5>
				<h4>{{ bestTry }}</h4>
			</article>
		</div>
		<br />
		<div id="board" class="position-relative">
			<h1 id="answer" v-if="showError"></h1>
		</div>
		<br />
		<!-- <button @click="newGame">New Game</button> -->
	</div>
</template>

<script>
import wordlemixins from "@/components/mixin/wordlemixins";
export default {
	components: {},
	mixins: [wordlemixins],
};
</script>

<style>
@keyframes flip {
	0% {
		transform: rotateX(0);
	}
	50% {
		transform: rotateX(90deg);
	}
	100% {
		transform: rotateX(0);
	}
}

.flip {
	animation: flip 0.5s ease-in-out;
	animation-fill-mode: forwards;
}

#answer {
	position: absolute;
	background-color: #ffffff;
	box-shadow: 0px 4px 16px 0px #0000003d;
	border-radius: 4px;
	padding: 15px 20px;
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 700;
	color: #333333;
	top: 24px;
	left: 82px;
	z-index: 4;
}

/* Ensure the board has proper dimensions */
#board {
	width: 300px;
	/* height: 550px; */
	/* margin: 0 auto; */
	margin-top: 3px;
	display: flex;
	flex-wrap: wrap;
}
#wordle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

#wordle #title {
	font-size: 32px;
	font-weight: 900;
	font-family: "Lato", sans-serif;
	color: var(--bg-proTheme);
}

.font-24 {
	font-size: 24px;
	font-weight: 600;
}

#wordle article {
	backdrop-filter: blur(4px);
	background-color: #d9e4f5;
	border-radius: 8px;
	padding: 10px;
	width: 120px;
	height: 75px;
	text-align: center;
}

#board .tile.active {
	border: 2px solid black;
}

#wordle article h5 {
	font-family: "Lato", sans-serif;
	font-size: var(--sixe-14);
	font-weight: var(--weight-LM);
	color: #595959;
}

#wordle article h4 {
	font-family: Lato;
	font-size: var(--sixe-20);
	font-weight: 900;
	color: var(--bg-proTheme);
	margin-bottom: 0;
}

/* Ensure tiles are displayed properly */
#board .tile {
	background-color: #f0f4f8;
	border-radius: 4px;
	border: none;
	width: 55px;
	height: 55px;
	margin: 2.5px;
	color: black;
	font-size: 29px;
	font-weight: 700;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

/* Ensure correct, present, and absent styles are applied */
.keyboard-row .correct,
#board .correct {
	background-color: #6aae54 !important;
}

.keyboard-row .present,
#board .present {
	background-color: #f4c300 !important;
}

.keyboard-row .absent,
#board .absent {
	background-color: #9a9a9a !important;
}

/* Style for keyboard rows */
.keyboard-row {
	width: 500px;
	/* border-radius: 10px; */
	background-color: #e8eaed;
	justify-content: center;
	display: flex;
	flex-wrap: wrap;
}

.keyboard-row-1 {
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	padding-top: 20px;
}

.keyboard-row-3 {
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
	padding-bottom: 20px;
	margin-bottom: 20px;
}

/* Style for key tiles */
.keyboard-row .key-tile {
	width: 36px;
	height: 40px;
	background-color: #d1d3d4;
	border-radius: 5px;
	margin: 4px;
	border: none;
	font-family: "Roboto", sans-serif;
	color: #333333;
	font-size: 16px;
	font-weight: 600;
	display: flex;
	justify-content: center;
	align-items: center;
}

/* Style for enter key tile */
.keyboard-row .enter-key-tile {
	width: 76px;
	height: 40px;
	margin: 4px;
	border: none;
	background-color: #d1d3d4;
	border-radius: 5px;
	font-family: "Roboto", sans-serif;
	color: #333333;
	font-size: 16px;
	font-weight: 600;
	display: flex;
	justify-content: center;
	align-items: center;
}
@keyframes shake {
	0% {
		transform: translateX(0);
	}
	25% {
		transform: translateX(-5px);
	}
	50% {
		transform: translateX(5px);
	}
	75% {
		transform: translateX(-5px);
	}
	100% {
		transform: translateX(0);
	}
}

.shake {
	animation: shake 0.5s ease-in-out;
}

@media (max-width: 1028px) {
	.keyboard-row {
		width: 350px;
		/* border-radius: 10px; */
		background-color: #e8eaed;
		justify-content: center;
		display: flex;
		flex-wrap: wrap;
	}

	.keyboard-row .key-tile {
		width: 3em;
		height: 37px;
		font-size: 10px;
		margin: 2px;
	}
	.keyboard-row #Backspace {
		width: 3.4em !important;
		height: 37px;
		font-size: 10px;
		margin: 2px;
	}
	.keyboard-row .enter-key-tile {
		height: 37px;
		width: 50px;
		font-size: 10px;
		margin: 2px;
	}
	.keyboard-row-1 {
		margin-top: 8px;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		padding-top: 15px;
	}
	.keyboard-row-3 {
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		padding-bottom: 15px;
	}
	.reset-wordle-hover {
		left: 160px;
	}
	.hint-wordle-hover {
		left: -6px;
	}
	#wordle article {
		width: 152px;
	}
}

@media (min-width: 334px) and (max-width: 372px) {
	.keyboard-row .key-tile {
		width: 27px;
		height: 41px;
	}
	.keyboard-row {
		width: 317px;
	}
	.keyboard-row .enter-key-tile,
	.keyboard-row #Backspace {
		height: 41px;
	}
}

@media (max-width: 333px) {
	.keyboard-row .key-tile {
		width: 24px;
		height: 41px;
	}
	.keyboard-row {
		width: 293px;
	}
	.keyboard-row .enter-key-tile,
	.keyboard-row #Backspace {
		height: 41px;
	}
}
</style>
